import React from 'react';
import Button from 'button';
import Headline from 'headline';
import Input from 'shared/form-input';

import s from './page-theme.module.scss';

function Title({ children }) {
  return <h2 className={s.title}>{children}</h2>;
}

function Clm({ children, full, nm }) {
  return (
    <div className={`${s.col} ${full ? s.full : ''} ${nm ? s.nm : ''}`}>
      {children}
    </div>
  );
}

function Section({ children, start }) {
  return (
    <section className={`${s.section} ${start ? s.start : ''}`}>
      {children}
    </section>
  );
}

function Color({ cl, dark }) {
  const color = cl.includes('#') ? cl : `#${cl}`;
  return (
    <div
      className={`${s.color} ${dark ? s.dark : ''}`}
      style={{ background: color }}
    >
      <span>{color.toUpperCase()}</span>
    </div>
  );
}

export default function Theme() {
  return (
    <main className={s.root}>
      <div className="container">
        <h1 className={s.titleBig}>THEME</h1>
        <br />
        <Title>Buttons</Title>
        <br />
        <Section>
          <Clm>
            <Button>Primary</Button>
          </Clm>
          <Clm>
            <Button secondary>Secondary</Button>
          </Clm>
          <Clm>
            <Button disabled>disabled primary</Button>
          </Clm>
          <Clm>
            <Button secondary disabled>
              disabled secondary
            </Button>
          </Clm>
        </Section>
        <br />
        <br />
        <Title>
          <span>Typography</span>
        </Title>
        <br />
        <Section>
          <Clm full>
            <Headline className={s.nm} h1 title orange>
              <span>Headline 1 Title</span>
            </Headline>
          </Clm>
          <Clm full>
            <Headline className={s.nm} h2 title>
              <span>Headline 2 Title</span>
            </Headline>
          </Clm>
          <Clm full>
            <Headline className={s.nm} h3 title>
              <span>Headline 3 Title</span>
            </Headline>
          </Clm>
          <Clm full>
            <Headline className={s.nm} h1>
              <span>Headline 1</span>
            </Headline>
          </Clm>
          <Clm full>
            <Headline className={s.nm} h2>
              <span>Headline 2</span>
            </Headline>
          </Clm>
          <Clm full>
            <Headline className={s.nm} h3>
              <span>Headline 3</span>
            </Headline>
          </Clm>
          <Clm full>
            <p className={s.nm}>Body Text</p>
          </Clm>
        </Section>
        <br />
        <br />
        <Title>FORMS</Title>
        <br />
        <Section start>
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input type="text" placeholder="form input" />
            </div>
          </Clm>
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input
                error
                type="text"
                placeholder="form input"
                className={s.input}
              />
            </div>
          </Clm>
          <Clm full nm />
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input white type="text" placeholder="form input flat" />
            </div>
          </Clm>
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input
                error
                white
                type="text"
                placeholder="form input flat error"
                className={s.input}
              />
            </div>
          </Clm>
          <Clm full nm />
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input textarea placeholder="textarea" />
            </div>
          </Clm>
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input
                error
                textarea
                placeholder="textarea error"
                className={s.input}
              />
            </div>
          </Clm>
          <Clm full nm />
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input white textarea placeholder="textarea flat" />
            </div>
          </Clm>
          <Clm>
            <div style={{ maxWidth: 400 }}>
              <Input
                white
                error
                textarea
                placeholder="textarea flat error"
                className={s.input}
              />
            </div>
          </Clm>
        </Section>
        <br />
        <br />
        <Title>
          <span>Color pallette</span>
        </Title>
        <br />
        <div className={s.colorWrapper}>
          <Color cl="#ffffff" dark />
          <Color cl="#f2f2f2" dark />
          <Color cl="d6d6d6" />
          <Color cl="949aa3" />
          <Color cl="#000000" />
          <Color cl="54c6e0" />
          <Color cl="21272f" />
          <Color cl="6063ab" />
          <Color cl="f47022" />
          <Color cl="#cd2e71" />
          <Color cl="#0ecdb8" />
          <Color cl="#64c87a" />
          <Color cl="#cc0000" />
        </div>
      </div>
    </main>
  );
}
